import { useCallback } from 'react';
import { useFormAdapter, useFormFields } from '@eti/providers';
import { generateMuxProductKey, getEmptyOptionId, getNewFormValues } from '../utils';
import * as allProducts from '../../products';
export const useMutuallyExclusiveState = products => {
  var _ref, _products$some;
  const {
    setValue,
    getValues
  } = useFormAdapter();
  const identifierKey = generateMuxProductKey(products);
  const {
    value: mutuallyExclusiveCardSelection
  } = useFormFields(`mutuallyExclusive.${identifierKey}`);
  const ancillaryBundleSelectedProducts = (_ref = getValues('ancillaryBundle.value.productsInSelection')) !== null && _ref !== void 0 ? _ref : [];
  const selectedProductSection = Object.values(allProducts).find(product => String('id' in product ? product.id : 0) === mutuallyExclusiveCardSelection);
  const selectedProductSectionName = selectedProductSection && 'name' in selectedProductSection ? selectedProductSection.name : '';
  const selectedProductState = selectedProductSectionName ? getValues(`${selectedProductSectionName}.value.value`) : null;
  const isSelectionValid = mutuallyExclusiveCardSelection === getEmptyOptionId(identifierKey) || mutuallyExclusiveCardSelection && selectedProductState;
  const isAnyProductSelectedInBundle = (_products$some = products === null || products === void 0 ? void 0 : products.some(product => ancillaryBundleSelectedProducts.includes(product.id))) !== null && _products$some !== void 0 ? _products$some : false;
  const selection = isSelectionValid ? mutuallyExclusiveCardSelection : null;
  const onChange = useCallback(selectedProductId => {
    const newFormValues = getNewFormValues(selectedProductId, products);
    newFormValues === null || newFormValues === void 0 || newFormValues.forEach(({
      fieldName,
      formValue
    }) => {
      if (!fieldName) {
        return;
      }
      setValue(fieldName, formValue);
    });
  }, [products, setValue]);
  return {
    isAnyProductSelectedInBundle,
    selection,
    onChange
  };
};
//# sourceMappingURL=useMutuallyExclusiveState.js.map